import request from "../request";


/**
 * 上传图片
 */
export const upLoadImage = (data)=>{
    console.log(data)
    return request({
        url: 'workspace/upLoad/image',
        headers: {
            "Content-type": "multipart/form-data",
        },
        method: 'POST',
        data: data
    });
}

/**
 * 上传文件
 */
export const uploadFiles = (data)=>{
    console.log(data)
    return request({
        url: 'workspace/upLoad/uploadFile',
        headers: {
            "Content-type": "multipart/form-data",
        },
        method: 'POST',
        data: data
    });
}
